import React, { useEffect, useState } from 'react';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { parseISO, parse } from 'date-fns';
import { getWearSumary } from '../../../utils/api';

// Register required Chart.js components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
  Tooltip,
  Legend,
  Filler
);

const WearTrendChart = ({ inspectionData, height = 300, setWearTrend,wearTrendRef }) => {
  let [wearSummary, setWearSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWearSummary = async () => {
      try {
        setLoading(true);
        // Assuming getWearSummary is an API call (e.g., from an API service)
        const result = await getWearSumary({
          equipment_id: inspectionData.equipment,
          equipment_no: inspectionData.equipment_no,
        });

       
    

        const dataByLocation = Array.isArray(result.data)
          ? result.data.reduce((acc, inspection) => {
            const { inspection_date, wear_summary } = inspection;
            if (!Array.isArray(wear_summary) || wear_summary.length === 0) return acc;

            const formattedInspectionDate = inspection_date
              ? parseISO(inspection_date).toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: '2-digit', //numeric = full year like  2025
              })
              : 'Unknown Date';

            // Build map of location -> { lifterVal, plateVal, installDate } for this inspection
            const locMap = {};
            wear_summary.forEach((row) => {
              const loc = row.location || 'UNKNOWN';
              const comp = (row.component || '').toUpperCase();
              const raw = String(row.remainingLife ?? '').replace(/,/g, '').trim();
              const val = Number(raw);
              const remainingLifeNum = Number.isFinite(val) ? val : null;

              locMap[loc] = locMap[loc] || { lifterVal: null, plateVal: null, installDate: row.installDate || null };
              if (comp === 'LIFTER') locMap[loc].lifterVal = remainingLifeNum;
              if (comp === 'PLATE') locMap[loc].plateVal = remainingLifeNum;
            });

            // For each location in this inspection, add label + values only if at least one component has a finite remainingLife
            Object.entries(locMap).forEach(([loc, { lifterVal, plateVal, installDate }]) => {
              if (lifterVal == null && plateVal == null) {
                // skip location for this inspection — no point to plot
                return;
              }

              if (!acc[loc]) acc[loc] = { labels: [], lifter: [], plate: [] };

              // Prepend install row once per location when first seen
              if (acc[loc].labels.length === 0 && installDate) {
                const parsedInstall = new Date(installDate);
                if (!Number.isNaN(parsedInstall.getTime())) {
                  const installLabel = `${parsedInstall.toLocaleDateString('en-US', {
                    month: 'short',
                    day: 'numeric',
                    year: '2-digit',
                  })}`;
                  if (!acc[loc].labels.includes(installLabel)) {
                    acc[loc].labels.unshift(installLabel);
                    acc[loc].lifter.unshift(100);
                    acc[loc].plate.unshift(100);
                  }
                }
              }

              // Add inspection date once and push only finite values (null otherwise)
              if (!acc[loc].labels.includes(formattedInspectionDate)) {
                acc[loc].labels.push(formattedInspectionDate);
                acc[loc].lifter.push(Number.isFinite(lifterVal) ? lifterVal : null);
                acc[loc].plate.push(Number.isFinite(plateVal) ? plateVal : null);
              }
            });

            return acc;
          }, {})
          : {};

          
              // ── NEW: +6‑month projection ──
              Object.entries(dataByLocation).forEach(([loc, { labels, lifter, plate }]) => {
                if (labels.length === 0) return;
                const lastLabel = labels[labels.length - 1];
                const lastDate   = parse(lastLabel, 'MMM d, yyyy', new Date());
                const futureDate = new Date(lastDate);
                futureDate.setMonth(futureDate.getMonth() + 6);
                const futureLabel = futureDate.toLocaleDateString('en-US', {
                  month: 'short',
                  day:   'numeric',
                  year:  '2-digit',
                });

                dataByLocation[loc].labels.push(`${futureLabel}`);
                dataByLocation[loc].lifter.push(null);
                dataByLocation[loc].plate.push(null);
              });

         setWearTrend(dataByLocation)
         setWearSummary(dataByLocation);




      } catch (error) {
        console.error('Error fetching wear summary:', error);
        setError('Failed to load wear summary data');
      } finally {
        setLoading(false);
      }
    };

    if (inspectionData?.equipment && inspectionData?.equipment_no) {
      fetchWearSummary();
    }
  }, [inspectionData]);

  // Group data by location only if wearSummary is available
  // let dataByLocation = wearSummary
  //   ? wearSummary.reduce((acc, inspection) => {
  //       const { inspection_date, wear_summary } = inspection;
  //       if (!wear_summary || !Array.isArray(wear_summary)) return acc;



  //       const formattedInspectionDate = parseISO(inspection_date).toLocaleDateString('en-US', {
  //         month: 'short',
  //         day: 'numeric',
  //         year: 'numeric',
  //       });

  //       wear_summary.forEach(({ location, component, remainingLife, installDate }) => {
  //         if (!acc[location]) {
  //           acc[location] = {
  //             labels: [],
  //             lifter: [],
  //             plate: [],
  //           };
  //         }

  //         // Add installDate at the front if not already included
  //         if (acc[location].labels.length === 0 && installDate) {
  //           const parsedInstallDate = new Date(installDate) // e.g., "04 Sept 25" to 2025-09-04
  //           acc[location].labels.unshift(`Installed on ${parsedInstallDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`);
  //           acc[location].lifter.unshift(100); // 100% remaining life at install
  //           acc[location].plate.unshift(100);  // 100% remaining life at install
  //         }

  //         // Add inspection_date and corresponding remainingLife if not already included
  //         if (!acc[location].labels.includes(formattedInspectionDate)) {
  //           acc[location].labels.push(formattedInspectionDate);
  //           const lifterEntry = wear_summary.find((item) => item.component === 'LIFTER');
  //           const plateEntry = wear_summary.find((item) => item.component === 'PLATE');
  //           acc[location].lifter.push(
  //             lifterEntry ? parseFloat(lifterEntry.remainingLife) || null : null
  //           );
  //           acc[location].plate.push(
  //             plateEntry ? parseFloat(plateEntry.remainingLife) || null : null
  //           );
  //         }
  //       });

  //       return acc;
  //     }, {})
  //   : {};







  // Render based on loading state
  if (loading) return <div>Loading wear trend data...</div>;
  if (error) return <div>{error}</div>;
  if (!wearSummary || Object.keys(wearSummary).length === 0) return <div>No wear trend data available</div>;




  // Render a chart for each location
  return (
    <div style={{ width: '100%' }}>
      {Object.entries(wearSummary).map(([location, { labels, lifter, plate }]) => {
        const data = {
          labels: labels, // Use exact formatted dates as categories
          datasets: [
            {
              label: 'Lifter',
              data: lifter,
              borderColor: '#0b5394', // dark blue
              backgroundColor: 'rgba(11,83,148,0.08)',
              tension: 0.25,
              fill: false,
              borderWidth: 2,
              pointRadius: 6,
              pointHoverRadius: 8,
              pointBackgroundColor: '#0b5394',
              pointBorderColor: '#ffffff',
              pointStyle: 'rectRot',
              borderDash: [6, 6],
            },
            {
              label: 'Plate',
              data: plate,
              borderColor: '#6fa8dc', // light blue
              backgroundColor: 'rgba(111,168,220,0.06)',
              tension: 0.25,
              fill: false,
              borderWidth: 2,
              pointRadius: 6,
              pointHoverRadius: 8,
              pointBackgroundColor: '#6fa8dc',
              pointBorderColor: '#ffffff',
              pointStyle: 'rectRot',
              borderDash: [6, 6],
            },
          ],
        };

        const options = {
          maintainAspectRatio: false,
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: `Wear Trend - ${location}`,
              font: { size: 16 },
            },
            tooltip: {
              mode: 'index',
              intersect: false,
            },
          },
          interaction: {
            mode: 'nearest',
            axis: 'x',
            intersect: false,
          },
          scales: {
            x: {
              type: 'category', // Use category scale for exact labels
              title: {
                display: true,
                text: 'Inspection Date',
              },
              ticks: {
                maxRotation: 0,
                autoSkip: false, // Ensure all labels are shown
              },
            },
            y: {
              min: 0,
              max: 100,
              ticks: {
                stepSize: 20,
              },
              title: {
                display: true,
                text: 'Remaining Life [%]',
              },
            },
          },
        };

        return (
          <div className=''
            key={location}
            ref={(el) => { if (wearTrendRef.current) wearTrendRef.current[location] = el; }}

            style={{
              width: '500px', // Square width in pixels (≈133mm at 96dpi)
              height: '300px', // Match height as per prop
              padding: '20px',
              boxSizing: 'border-box',
              background: '#fff',
              border: '1px solid #ccc',
              marginBottom: '40px',
            }}
          >
            
            <Line data={data} options={options} />
          </div>
        );
      })}
    </div>
  );
};


export default WearTrendChart;